import { useLayoutEffect, useState } from 'react'

import RunnerGoalIcon from '@/components/Runner/RunnerGoalIcon'
import { CollectStatus } from '@/webgl/runner/entities/CollectibleEntity'
import { SequenceCompletion } from '@/webgl/runner/scenarios/SequenceCompletion'

import RunnerGoalEquationSearched from './RunnerGoalEquationSearched'

export type RunnerGoalEquationProps = {
  // template: string;
  template?: string
  suffix?: string
  completion: SequenceCompletion
  exiting?: boolean
}

export type PartVariant = {
  key: string
  text?: string
  image?: string
  small?: boolean
  // imageUrl?: string;
  hasBackground?: boolean
  goal?: PartVariant
}
const partVariants: PartVariant[] = [
  {
    key: '+',
    image: 'add',
    small: true,
  },
  {
    key: '-',
    image: 'subtract',
    small: true,
  },
  {
    key: 'x',
    image: 'multiply',
    small: true,
  },
  {
    key: '/',
    image: 'divide',
    small: true,
  },
  {
    key: '=',
    image: 'equal',
    small: true,
  },
  {
    key: '(',
    text: '(',
  },
  {
    key: ')',
    text: ')',
  },

  {
    key: 'R1',
    text: 'I',
  },
  {
    key: 'R2',
    text: 'II',
  },
  {
    key: 'R3',
    text: 'III',
  },
  {
    key: 'R4',
    text: 'IV',
  },
  {
    key: 'R5',
    text: 'V',
  },
  {
    key: 'R6',
    text: 'VI',
  },
  {
    key: 'R7',
    text: 'VII',
  },
  {
    key: 'R8',
    text: 'VIII',
  },
  {
    key: 'R9',
    text: 'IX',
  },
  {
    key: 'R10',
    text: 'X',
  },

  {
    key: 'R1_shape',
    image: 'R1_shape',
  },
  {
    key: 'R2_shape',
    image: 'R2_shape',
  },
  {
    key: 'R3_shape',
    image: 'R3_shape',
  },
  {
    key: 'R4_shape',
    image: 'R4_shape',
  },
  {
    key: 'R5_shape',
    image: 'R5_shape',
  },
  {
    key: 'R6_shape',
    image: 'R6_shape',
  },
  {
    key: 'R7_shape',
    image: 'R7_shape',
  },
  {
    key: 'R8_shape',
    image: 'R8_shape',
  },
  {
    key: 'R9_shape',
    image: 'R9_shape',
  },
  {
    key: 'R10_shape',
    image: 'R10_shape',
  },

  {
    key: 'goal',
    image: 'goal',
    hasBackground: true,
  },
]

const RunnerGoalEquation = ({ template, suffix, completion, exiting }: RunnerGoalEquationProps) => {
  const [items, setItems] = useState([])
  const block = completion.blocks[completion.currentBlock]

  useLayoutEffect(() => {
    const elements = template
      .split(/{{(.*?)}}/g)
      .filter((item) => item !== '')
      .map((item) => item.trim())
    const items = elements.map((element) => partVariants.find((part) => part.key === element))

    let index = 0
    items.forEach((item, i) => {
      if (item) {
        if (item.key === 'goal') {
          const goal = block.goal[index]
          const suffixedGoal = goal + (suffix ? suffix : '')
          item.goal =
            block.goal.length > index
              ? partVariants.find((part) => part.key == suffixedGoal || (part.image && part.image == suffixedGoal))
              : null
          index++
        }
      }
    })

    setItems(items)
  }, [template, setItems, block, suffix])

  return (
    template && (
      <div className='RunnerGoalVariant Runner__goal-equation relative px-16 flex items-center bg-tertiary min-h-88 min-w-88 p-8 rounded-24 gap-10 border-4 border-mid-blue mt-12'>
        {items.map((item, index) => {
          if (item) {
            if (item.key === 'goal') {
              return (
                <RunnerGoalEquationSearched
                  key={index}
                  goal={item.goal}
                  collected={exiting && block.status === CollectStatus.Succeed}
                />
              )
            } else if (item.text) {
              return (
                <span key={index} className='Equation__Text text-light-blue text-32 md:text-48 lg:text-58 font-black'>
                  {item.text}
                </span>
              )
            } else {
              return (
                <RunnerGoalIcon
                  className={`${item.small ? 'w-36! h-36! lg:w-64! lg:h-64!' : 'w-auto!'}`}
                  key={index}
                  searched={false}
                  collected={false}
                  image={item.image}
                  index={item.hasBackground ? index : -1}
                />
              )
            }
          }
        })}
      </div>
    )
  )
}

export default RunnerGoalEquation
